import $router from "@/router";

export default function ($route, queryParams) {
    let isEqual = true;

    for (let [key, value] of Object.entries(queryParams)) {
        if (value && !$route.query[key]) isEqual = false;
        if ($route.query[key] && parseInt($route.query[key]) !== value)
            isEqual = false;
    }

    if (isEqual) return;

    const route = {
        name: $route.name,
        params: $route.params,
        query: { ...$route.query, ...queryParams },
    };

    $router.replace(route);
}
